module.exports = __webpack_public_path__ + "img/logo-full-white.d4963b86.svg";